import * as React from 'react';
import { ContainerBase } from '@/components/landing';
import { LoaderScreen } from '@/components/common';
import { formatStates } from '@/lib';
import { CaseDetailI } from '@/interfaces';
import { HttpResponse } from '@/interfaces/httpClient';
import { SummaryCard } from './SummaryCard';
import { FileYourClaimScreen } from '../FileYourClaim';
import { useMediaQuery } from 'react-responsive';

export const CaseDetailsLandingScreen = ({
	previewMode,
	caseData,
}: {
	previewMode?: boolean;
	caseData?: HttpResponse<CaseDetailI | undefined>;
}) => {
	const [isLoading, setIsLoading] = React.useState(true);

	const isDesktopOrLaptop = useMediaQuery({
		query: '(min-width: 1024px)',
	});

	React.useEffect(() => {
		setIsLoading(false);
	}, [caseData?.data?.id]);

	const caseDetail = caseData?.data;
	const { statesToList, statesToModal } = formatStates(
		caseDetail?.states,
		isDesktopOrLaptop
	);
	if (isLoading || !caseDetail) {
		return <LoaderScreen />;
	}

	return (
		<ContainerBase className="min-h-screen relative overflow-hidden !px-0 lg:!px-[84px] 3xl:!px-[84px] xl:pb-[50px] bg-[linear-gradient(107.11deg,#EDE9F3_0%,#FFFFFF_100.5%)]">
			<div className="relative z-10 flex flex-col lg:flex-row items-star justify-between gap-11 3xl:justify-center 3xl:gap-[177px] pt-6 xl:pt-12">
				<SummaryCard
					title={caseDetail?.title}
					caseStatus={caseDetail?.status}
					statesToModal={statesToModal}
					statesToList={statesToList}
					criteria={caseDetail?.eligibility_criteria ?? ''}
					previewMode={previewMode}
					aboutClaim={caseDetail.about_claim ?? ''}
				/>

				<FileYourClaimScreen
					id={caseData?.data?.id ?? ''}
					status={caseDetail?.status}
				/>
			</div>
		</ContainerBase>
	);
};
